import * as formulas from './calcs/formulas';

export default {
  formulas,
};
